import FormRedirection from '../../../common/scripts/FormRedirection';
import './Default.scss';

FormRedirection.init()
ComponentManager.init(document.body);
